import React from "react";
import { motion } from "framer-motion";
import { HelpCircle } from "lucide-react";
import { useLang, faqData } from "@/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQ = () => {
  const { t, lang } = useLang();
  const data = faqData[lang];
  return (
    <section id="faq" className="relative py-24 sm:py-32 max-w-4xl mx-auto px-5 sm:px-8" data-testid="faq">
      <div className="mb-12 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-accent/10 mb-5">
          <HelpCircle className="w-6 h-6 text-accent" strokeWidth={1.5} />
        </div>
        <h2 className="font-display text-3xl sm:text-5xl font-bold">{t.faq.title}</h2>
        <p className="mt-4 text-muted-foreground text-lg">{t.faq.subtitle}</p>
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {data.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}
              className="border border-white/10 rounded-xl px-5 bg-card data-[state=open]:border-accent/40 transition-colors">
              <AccordionTrigger className="text-left font-display font-semibold hover:no-underline py-5 text-[15px]">{item.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5 text-sm">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
};
